require('../modules/es7.object.get-own-property-descriptors');
require('../modules/es7.object.values');
require('../modules/es7.object.entries');
require('../modules/es7.object.define-getter');
require('../modules/es7.object.define-setter');
require('../modules/es7.object.lookup-getter');
require('../modules/es7.object.lookup-setter');
module.exports = require('../modules/_core').Object;



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/es7/object.js
 ** module id = 342
 ** module chunks = 0 1
 **/